import {LoadingSvg} from '@/icons';
import styles from './index.module.scss';

export function Loading() {
    return <div className={styles.loadingStatus}>
        <div className={styles.loadingStatusIcon} />
        加载中...
    </div>;
}

export function Loaded() {
    return <div className={styles.loadedStatus}></div>;
}

export function NoResult() {
    return <div className={styles.nullStatus}>未找到相关结果</div>;
}

interface IError {
    onReload: () => void;
}
export function LoadError(props: IError) {
    const {onReload} = props;
    return <div className={styles.errorStatus}>加载失败，<span onClick={onReload}>重新加载</span></div>;
}

export function CloseTips() {
    return <div className={styles.loadedStatus}>管理员已关闭浏览记录</div>;
}
